export interface SubcategoryProps {
  id: string;
  name: string;
  slug: string;
  description?: string | null;
  itemCount?: number;
  imageId?: string | null;
  imageUrl?: string | null;
  status?: string | boolean;
  displayOrder?: number;
  categoryId?: string;
  categoryName?: string;
  categorySlug?: string;
}

export interface CategoryProps {
  id: string;
  name: string;
  slug: string;
  description: string;
  itemCount: number;
  subcategories?: SubcategoryProps[];
  // Dashboard admin fields
  imageId?: string | null;
  imageUrl?: string | null;
  status?: string | boolean;
  showOnHome?: boolean;
  displayOrder?: number;
}

export class CategoryEntity {
  constructor(private readonly props: CategoryProps) {
    if (!props.id) throw new Error('El ID de categoría es obligatorio');
    if (!props.name) throw new Error('El nombre de categoría es obligatorio');
    if (!props.slug) throw new Error('El slug de categoría es obligatorio');
  }

  get id(): string {
    return this.props.id;
  }

  get name(): string {
    return this.props.name;
  }

  get slug(): string {
    return this.props.slug;
  }

  get description(): string {
    return this.props.description;
  }

  get itemCount(): number {
    return this.props.itemCount;
  }

  get subcategories(): SubcategoryProps[] {
    return this.props.subcategories ? [...this.props.subcategories] : [];
  }

  get imageId(): string | null {
    return this.props.imageId ?? null;
  }

  get imageUrl(): string | null {
    return this.props.imageUrl ?? null;
  }

  get status(): 'active' | 'inactive' {
    const raw = this.props.status as unknown;
    if (raw === false || raw === 'false' || raw === 'inactive' || raw === 'INACTIVE' || raw === 0) {
      return 'inactive';
    }
    return 'active';
  }

  get showOnHome(): boolean {
    return !!this.props.showOnHome;
  }

  get displayOrder(): number {
    return this.props.displayOrder ?? 0;
  }

  toJSON(): CategoryProps {
    return {
      ...this.props,
      status: this.status,
      showOnHome: this.showOnHome,
      subcategories: this.subcategories,
    };
  }
}
